import { Grid, Stack } from "@mui/material";
import { FormSection } from "Components/Shared/FormSection";
import { GridItem } from "Components/Shared/GridItem";
import { DocumentValidityInfo } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/DocumentValidityInfo";
import { AddressesSection } from "Components/Users/UserDetailPageContent/Components/PartyReadOnlyDetail/AddressesSection";
import { useCheckPermission } from "Hooks/usePermission";
import { type PartyDto, Permission } from "Infrastructure/Api/Api";
import { AccessRightCodes } from "Models/AccessRightCodes";
import { Resources, useResource } from "Translations/Resources";
import { formatDate } from "Utils/DateUtils";
import { useCountryNameResolver } from "Translations/countryNames";

const FIELD_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.RelatedParties.Form.Fields
    .BeneficialOwnerFields;

type Props = {
  partyData: PartyDto;
};

export const BeneficialOwnerReadOnly = ({ partyData }: Props) => {
  const { t } = useResource();
  const { getCountryName } = useCountryNameResolver();
  const canSeeDocuments = useCheckPermission(
    AccessRightCodes.IDDocuments,
    Permission.Read,
  );
  const countryName = getCountryName(partyData.nationality);

  return (
    <Stack gap={4}>
      <FormSection legend={t(FIELD_RESOURCES.Legend.PersonalData)} noMargins>
        <Grid container spacing={2}>
          <GridItem
            label={t(FIELD_RESOURCES.FirstName)}
            value={partyData.firstName}
          />
          <GridItem
            label={t(FIELD_RESOURCES.LastName)}
            value={partyData.lastName}
          />
          <GridItem
            label={t(FIELD_RESOURCES.BirthDate)}
            value={formatDate(partyData.birthDate)}
          />
          <GridItem
            label={t(FIELD_RESOURCES.Nationality)}
            value={countryName}
          />
        </Grid>
      </FormSection>
      {!canSeeDocuments && <DocumentValidityInfo partyData={partyData} />}
      <AddressesSection party={partyData} />
    </Stack>
  );
};
